import { useSelector } from 'react-redux';
import { AssistantSmartTipsParameters, useRepositoryQuery } from '@mews-commander/data-access';
import { useLanguageCode } from '@mews-commander/core';
import { isCurrentEnterpriseSmartTipsEnabled } from '@mews-commander/legacy-entities/src/selectors/session/subscription';

export const useAssistantSmartTipsQuery = (
    { id, entity, enterpriseIds, chainId }: AssistantSmartTipsParameters,
    enabled = true
) => {
    const isSmartTipsEnabled = useSelector(isCurrentEnterpriseSmartTipsEnabled);
    const languageCode = useLanguageCode();

    return useRepositoryQuery(
        'assistantSmartTips',
        'generate',
        {
            id,
            entity,
            chainId,
            enterpriseIds,
            languageCode,
        },
        {
            enabled: !!id && !!isSmartTipsEnabled && enabled,
            staleTime: 0,
        }
    );
};
